import apiClient, { retryRequest } from "./axios";

/**
 * AI待办事项API
 */
export const aiActionItemApi = {
    /**
     * 获取待处理的AI建议
     * @param {Object} params 查询参数
     * @returns {Promise<Object>} AI建议列表
     */
    getPendingAiActionItems: async (params = {}) => {
        try {
            // 设置默认参数值
            const queryParams = {
                status: "PENDING",
                page_size: 50,
                ...params,
            };

            const response = await apiClient.get("/v1/action_items", { params: queryParams });
            return response;
        } catch (error) {
            console.error("获取待处理AI建议失败:", error);
            throw error;
        }
    },

    /**
     * 获取单个AI建议详情
     * @param {number} actionItemId 建议ID
     * @returns {Promise<Object>} AI建议详情
     */
    getAiActionItemById: async (actionItemId) => {
        try {
            const response = await retryRequest(
                () => apiClient.get(`/v1/action_items/${actionItemId}`),
                3, // 最大重试3次
                1000, // 初始延迟1秒
            );
            return response;
        } catch (error) {
            console.error(`获取AI建议ID=${actionItemId}的详情失败:`, error);
            throw error;
        }
    },

    /**
     * 处理AI建议
     * @param {number} actionItemId 建议ID
     * @param {string} action 处理动作 'CONFIRMED', 'REJECTED', 'MODIFIED'
     * @param {Object} additionalData 额外数据，如修改后的值
     * @returns {Promise<Object>} 处理结果
     */
    processAiActionItem: async (actionItemId, action, additionalData = {}) => {
        try {
            const payload = {
                action,
                ...additionalData,
            };

            const response = await apiClient.post(`/v1/action_items/${actionItemId}/process`, payload);
            return response;
        } catch (error) {
            console.error(`处理AI建议ID=${actionItemId}失败:`, error);
            throw error;
        }
    },

    /**
     * 获取与特定航班相关的AI建议
     * @param {number} flightId 航班ID
     * @param {Object} params 查询参数
     * @returns {Promise<Array>} AI建议列表
     */
    getFlightAiActionItems: async (flightId, params = {}) => {
        try {
            // 设置默认参数值
            const queryParams = {
                flight_operation_id: flightId,
                ...params,
            };

            const response = await apiClient.get("/v1/action_items", { params: queryParams });
            return response;
        } catch (error) {
            console.error(`获取航班ID=${flightId}的AI建议失败:`, error);
            throw error;
        }
    },

    /**
     * 获取未处理的AI建议数量
     * @returns {Promise<number>} 未处理的AI建议数量
     */
    getPendingAiActionItemsCount: async () => {
        try {
            const response = await apiClient.get("/v1/action_items/count", {
                params: { status: "PENDING" },
            });
            // 确保 response.data 存在且有 count 属性
            return response;
        } catch (error) {
            console.error("获取未处理AI建议数量失败:", error);
            // 返回 0 改为抛出错误
            throw error;
        }
    },
};

export default aiActionItemApi;
